import { render } from "./BtnTooltip.vue?vue&type=template&id=504d4b4a&scoped=true"
import script from "./BtnTooltip.vue?vue&type=script&lang=js"
export * from "./BtnTooltip.vue?vue&type=script&lang=js"

import "./BtnTooltip.vue?vue&type=style&index=0&id=504d4b4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504d4b4a"]])

export default __exports__